import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-48">
      {/* Background Glows */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-cyan-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-49" />
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5 pointer-events-none" data-id="element-50" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-51">
        <div className="text-center max-w-4xl mx-auto" data-id="element-52">
          <FadeIn data-id="element-53">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 font-medium text-sm mb-8" data-id="element-54">
              <span className="relative flex h-2 w-2" data-id="element-55">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan-400 opacity-75" data-id="element-56"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-cyan-500" data-id="element-57"></span>
              </span>
              Sistema de Productividad Corporativa
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-58">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight mb-6 leading-tight" data-id="element-59">
              El Manual del Empleado Invisible:{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500" data-id="element-60">
                Recupera 10 Horas de tu Semana
              </span>{' '}
              (Sin que tu Jefe lo Note)
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-61">
            <p className="text-xl md:text-2xl text-[#d1d5db] mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-62">
              Deja de pelear con ChatGPT. Usa el sistema de "Anti-Prompting"
              para automatizar tus tareas aburridas y terminar tu jornada a las
              2:00 PM.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="flex flex-col items-center" data-id="element-63">
            <CTAButton data-id="element-64" />
            <p className="mt-4 text-sm text-slate-400 flex items-center gap-2" data-id="element-65">
              <span className="text-green-400" data-id="element-66">✓</span> Acceso instantáneo •
              Pago seguro
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} className="mt-16 md:mt-24 relative max-w-5xl mx-auto" data-id="element-67">
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0f1a] via-transparent to-transparent z-10 h-full w-full" data-id="element-68" />
          <div className="relative rounded-2xl overflow-hidden border border-slate-800 shadow-[0_0_50px_rgba(6,182,212,0.1)]" data-id="element-69">
            <img src="https://cdn.magicpatterns.com/uploads/fFqTtR2HWnYQXRRMucXeFB/heylloyd-image-1773283623251.png" alt="El Manual del Empleado Invisible en laptop" className="w-full h-auto object-cover" data-id="element-70" />
          </div>
        </FadeIn>
      </div>
    </section>;
}